import type { SelectFilterField } from '@/components/common/AdvancedFilter';
import { BOOLEAN_FILTER_VALUE } from '@/utils/filters';

export function getCollectionFilterField(): SelectFilterField {
  return {
    key: 'collected',
    label: 'Collection',
    type: 'select',
    options: [
      { label: 'Something handed in', value: BOOLEAN_FILTER_VALUE.yes },
      { label: 'Nothing handed in', value: BOOLEAN_FILTER_VALUE.no },
    ],
  };
}

export function getNewPapersFilterField(): SelectFilterField {
  return {
    key: 'isNew',
    label: 'Papers',
    type: 'select',
    options: [
      { label: 'New to me only', value: BOOLEAN_FILTER_VALUE.yes },
      { label: 'Already seen', value: BOOLEAN_FILTER_VALUE.no },
    ],
  };
}
